import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const environment = process.env.NX_ENVIRONMENT || "development";

const mapEnvToInstance = {
  local: "Local",
  playground: "Playground",
  development: "Development",
  test: "Test",
  release_candidate: "Release Candidate",
  staging: "Staging",
  production: "Production"
};

const instanceName = mapEnvToInstance[environment] || "Unknown Environment";

export const Instance = () => {
  if (environment === "production") {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center" mb={4}>
      <Typography>Instance: {instanceName}</Typography>
    </Box>
  );
};
